<div class="container">
    <div class="row">
        <div class="col-md-12">
            <div class="error-template">
                <h1>
                    Oops!</h1>
                <h2>
                    No {{title}} Found</h2>
                <div *ngIf="hide == '' " class="error-details">
                    Create your first entry
                </div>
                <!-- <div *ngIf="hide != 'sidebarEvents'" class="error-actions">
                    <a routerLink="route" class="btn main-backgroundcolor color btn-lg"><span
                            class="glyphicon glyphicon-home"></span>
                        Create {{title}} </a>
                </div> -->
            </div>
        </div>
    </div>
</div>